
import { GetBaseUrl } from "@/utils/ConfigHelper"
import Response from "@/utils/Videomonster/Common/Response"
import axios from "axios"
import { PUBLIC_ERROR_CODE } from '@/utils/Error/Constants'
import { GetPublicErrorCode } from '@/utils/Error/Handler'

/**
 * @param token
 * @param {{
 *  videoId
 * }} data
 * @return {Promise<Response>}
 */

const GetMusicList = async (token, data) => {
    try {
        const url = `${GetBaseUrl()}/apis/music/?${data.videoId}}`
        const config = { headers: { Authorization: `Bearer ${token}` } }
        const response = await axios.get(url, config)

        const result = (response.status === 200)
        const resultData = response.data.data

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

export default {
    GetMusicList
}